import(/* webpackMode: "eager" */ "/vercel/path0/client/src/components/layouts/page-layout/pageLayout.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/client/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["UserInfo"] */ "/vercel/path0/client/src/components/user/userInfo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MessageChannelInit"] */ "/vercel/path0/client/src/providers/messageChannelInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/vercel/path0/node_modules/next-auth/react.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"IBM_Plex_Sans\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"ibmPlexSans\"}");
